import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {ManagerService} from "../../serverService/managerManagement/ManagerService";
import {
    managerAccessLevelHeader,
    prepareManagerAccessLevelTableRow
} from "../../component/manangerDetail/ManagerAccessLevelTable";
import {ManagerAccessLevelService} from "../../serverService/managerAccessLevelService/ManagerAccessLevelService";
import RaikoDefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/RaikoDefaultDialogPage";
import ManagerRegisterResultInfo from "../../component/managerRegisterResultInfo/ManagerRegisterResultInfo";
import {
    RaikoMultiSelectTable,
    RaikoAlert,
    raikoAlertTypes,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMobileInputOutlined,
    RaikoSimpleInputOutlined,
    RaikoNumberInputOutlined,
    RaikoButtonPrimary, RaikoFlexAlignEnd
} from "@moeindal/base-raiko-panel-components";

const ManagerAddNew = ({changeNeedRefresh}) => {
    let page = 0
    const size = 15

    const serviceManager = new ManagerService()

    const snackbarDispatch = useSnackbarDispatcher();
    const snackbar = new SnackbarHelper(snackbarDispatch)

    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)


    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [userName, setUserName] = useState("")
    const [nationalCode, setNationalCode] = useState("")

    const [pageCount, setPageCount] = useState(0)
    const [accessLevel, setAccessLevel] = useState([])
    const [roleTableLoading, setRoleTableLoading] = useState(false);
    const [selectedAccessLevels, setSelectedAccessLevels] = useState([]);


    function handleChangePagination(newPage) {
        page = newPage
        getManagerAccessLevels()
    }

    useEffect(() => {
        getManagerAccessLevels()
    }, []);

    function getManagerAccessLevels() {
        new ManagerAccessLevelService().getAccessLevelList(page, size)
            .then(response => {
                setPageCount(response.totalPage)

                setAccessLevel([])
                response.data.map((item, index) => {
                    setAccessLevel(prevState => [
                        ...prevState,
                        prepareManagerAccessLevelTableRow(item.id, page * size + index + 1, item.title, item.name)
                    ])
                })

            }).catch(reason => {
            snackbar.showServerErrorMessage(reason, "")
        }).finally(_ => {
            setRoleTableLoading(false)
        })
    }

    function checkFieldsNotEmpty() {
        let state = false;

        if (firstName.length === 0) {
            showWarningMessage("خطا، لطفا نام مدیر را به درستی وارد نمایید!");
        } else if (lastName.length === 0) {
            showWarningMessage("خطا، لطفا نام خانوادگی مدیر را به درستی وارد نمایید!");
        } else if (phoneNumber.length !== 11) {
            showWarningMessage("خطا، لطفا شماره همراه مدیر را به درستی وارد نمایید!");
        } else if (nationalCode.length < 8) {
            showWarningMessage("خطا، لطفا کد ملی مدیر را به درستی وارد نمایید!")
        } else if (userName.length < 8) {
            showWarningMessage("خطا، نام کاربری باید حداقل ۸ کاراکتر باشد!");
        } else if (selectedAccessLevels.length === 0) {
            showWarningMessage("خطا، لطفا سطح دسترسی مدیر به سامانه را مشخص نمایید!");
        } else
            state = true;

        return state;
    }

    function showWarningMessage(message) {
        snackbar.showWarningMessage(message)
    }

    function handleChange() {
        if (checkFieldsNotEmpty()) {
            loading.show()
            serviceManager.addNewManager(firstName, lastName, nationalCode, phoneNumber, userName, selectedAccessLevels)
                .then(response => {
                    changeNeedRefresh(true)

                    setAdminUsername(response.username)
                    setAdminPassword(response.password)
                    setOpenDialog(true)

                }).catch(reason => {
                snackbar.showServerErrorMessage(reason)
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function clearFields() {
        setFirstName("")
        setLastName("")
        setNationalCode("")
        setPhoneNumber("")
        setUserName("")
        setPhoneNumber("")
        setSelectedAccessLevels([])
    }


    const [openDialog, setOpenDialog] = useState(false);
    const [adminUsername, setAdminUsername] = useState("");
    const [adminPassword, setAdminPassword] = useState("");

    function handleCloseDialog() {
        setOpenDialog(false)
        clearFields()
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"اطلاعات مدیر"}
            >
                <ManagerRegisterResultInfo
                    handleCloseDialog={handleCloseDialog}
                    alertTitle={"مدیر جدید با موفقیت افزوده شد."}
                    alertDescription={[
                        `* نام کاربری، گذر واژه و نشانی سامانه از طریق پیامک (${phoneNumber}) برای مدیر محترم ارسال شد.`,
                    ]}
                    username={adminUsername}
                    password={adminPassword}
                />
            </RaikoDefaultDialogPage>
            <RaikoGridOneColumn
                className={css`
                    padding: 0 1rem 1rem 1rem;
                    width: 100%;
                    height: 100%;`}
            >
                <RaikoAlert
                    type={raikoAlertTypes.info}
                    title={"بعد از افزودن مدیر جدید به طور خودکار پیامکی حاوی اطلاعات ورود و نشانی سامانه برای مدیر ارسال خواهد شد، لطفا در ورود شماره ی همراه مدیر دقت لازم را به همراه داشته باشید."}
                />

                <RaikoGridTwoColumn>
                    <RaikoSimpleInputOutlined
                        value={firstName}
                        setValue={setFirstName}
                        labelText={"نام"}
                    />
                    <RaikoSimpleInputOutlined
                        value={lastName}
                        setValue={setLastName}
                        labelText={"نام خانوادگی"}
                    />
                    <RaikoNumberInputOutlined
                        maxLength={"10"}
                        value={nationalCode}
                        setValue={setNationalCode}
                        labelText={"کد ملی"}
                    />

                    <RaikoMobileInputOutlined
                        value={phoneNumber}
                        setValue={setPhoneNumber}
                        labelText={"شماره همراه"}
                    />
                    <RaikoSimpleInputOutlined
                        value={userName}
                        setValue={setUserName}
                        labelText={"نام کاربری"}
                    />
                </RaikoGridTwoColumn>

                <RaikoMultiSelectTable
                    pageCount={pageCount}
                    setSelectedItems={setSelectedAccessLevels}
                    handleChangePagination={handleChangePagination}
                    tableData={accessLevel}
                    tableHeader={managerAccessLevelHeader}
                    selectedItems={selectedAccessLevels}
                    isSingleSelect={false}
                    tableLoadingState={roleTableLoading}
                    selectedItemsTitle={"سطح دسترسی"}
                    tableHintTitle={"سطح دسترسی مورد نظر را انتخاب نمایید."}
                />

                <RaikoFlexAlignEnd>
                    <RaikoButtonPrimary label={"افزودن مدیر"} onClick={handleChange}/>
                </RaikoFlexAlignEnd>
            </RaikoGridOneColumn>


        </>

    )
}
export default ManagerAddNew

